import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import grey from '@material-ui/core/colors/grey';
import { ConnectedRouter } from 'connected-react-router';
import { history } from './configureStore';
import AppContent from './AppContent';
import '../node_modules/react-resizable/css/styles.css';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0075A7',
            dark: '#005586',
        },
        secondary: {
            main: grey[700],
        },
    },
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiStepIcon: {
            root: {
                color: grey[600],
            },
        },
    },
});

const mapDispatchToProps = () => ({
    onLoad: () => {},
});

const mapStateToProps = ({ site }) => {
    return {
        appTitle: site.title,
    };
};

class App extends Component {
    componentDidMount() {
        this.props.onLoad();
        document.title = this.props.appTitle;
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <ConnectedRouter history={history}>
                    <SnackbarProvider
                        maxSnack={1}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <AppContent />
                    </SnackbarProvider>
                </ConnectedRouter>
            </MuiThemeProvider>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
